import { useEffect, useRef } from 'react';
import { useAuth } from '@/hooks/useAuth';

export const ScriptInjector = () => {
  const { user } = useAuth();
  const injectedNodesRef = useRef<Node[]>([]);

  useEffect(() => {
    // Función para procesar nodos y ejecutar scripts
    const processNode = (node: Node): Node => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        const element = node as Element;
        
        if (element.tagName.toLowerCase() === 'script') {
          const scriptElement = element as HTMLScriptElement;
          const newScript = document.createElement('script');

          // Copiar todos los atributos
          Array.from(scriptElement.attributes).forEach(attr => {
            newScript.setAttribute(attr.name, attr.value);
          });

          // Copiar src si existe
          if (scriptElement.src) {
            newScript.src = scriptElement.src;
          }

          // Copiar contenido inline
          if (scriptElement.textContent) {
            newScript.textContent = scriptElement.textContent;
          }

          return newScript;
        } else {
          // Para otros elementos, clonar y procesar hijos recursivamente
          const clonedElement = element.cloneNode(false) as Element;
          
          Array.from(element.childNodes).forEach(child => {
            const processedChild = processNode(child);
            clonedElement.appendChild(processedChild);
          });
          
          return clonedElement;
        }
      } else {
        return node.cloneNode(false);
      }
    };

    const loadCustomScript = async () => {
      if (!user || !user.tenantId) {
        return;
      }

      try {
        // Inyectar datos del usuario ANTES de cargar scripts
        (window as any).__USER_DATA__ = {
          userId: user.id,
          userName: user.fullName,
          userEmail: user.email,
          tenantId: user.tenantId,
        };

        const response = await fetch('/api/company', {
          credentials: 'include',
        });

        if (!response.ok) {
          console.warn('No se pudo cargar información de la empresa');
          return;
        }

        const company = await response.json();

        if (company.customScript && company.customScript.trim()) {
          // Crear contenedor temporal
          const tempContainer = document.createElement('div');
          tempContainer.innerHTML = company.customScript.trim();

          const fragment = document.createDocumentFragment();

          // Procesar todos los nodos
          Array.from(tempContainer.childNodes).forEach((node) => {
            const processedNode = processNode(node);
            fragment.appendChild(processedNode);
            injectedNodesRef.current.push(processedNode);
          });

          // Agregar al body
          document.body.appendChild(fragment);
        }
      } catch (error) {
        console.error('Error cargando script personalizado:', error);
      }
    };

    loadCustomScript();

    // Cleanup al desmontar
    return () => {
      injectedNodesRef.current.forEach(node => {
        if (node.parentNode) {
          node.parentNode.removeChild(node);
        }
      });
      injectedNodesRef.current = [];

      // Limpieza adicional para widgets comunes
      const geminiButton = document.getElementById('gemini-chat-button');
      const geminiIframe = document.getElementById('gemini-chat-iframe');
      if (geminiButton) geminiButton.remove();
      if (geminiIframe) geminiIframe.remove();
    };
  }, [user]);

  return null;
};
